import { subDays } from 'date-fns'

/**
 * Common date ranges
 */
export const dateRanges = {
	today: () => {
		const now = new Date()
		return { start: now, end: now }
	},
	last7Days: () => {
		const end = new Date()
		const start = subDays(end, 7) // 7 days including today
		return { start, end }
	},
	last30Days: () => {
		const end = new Date()
		const start = subDays(end, 30) // 30 days including today
		return { start, end }
	},
	last60Days: () => {
		const end = new Date()
		const start = subDays(end, 60) // 60 days including today
		return { start, end }
	},
	last90Days: () => {
		const end = new Date()
		const start = subDays(end, 90) // 90 days including today
		return { start, end }
	},
	last180Days: () => {
		const end = new Date()
		const start = subDays(end, 180) // 180 days including today
		return { start, end }
	},
	thisMonth: () => {
		const now = new Date()
		const start = new Date(now.getFullYear(), now.getMonth(), 1)
		const end = new Date(now.getFullYear(), now.getMonth() + 1, 0)
		return { start, end }
	},
	lastMonth: () => {
		const now = new Date()
		const start = new Date(now.getFullYear(), now.getMonth() - 1, 1)
		const end = new Date(now.getFullYear(), now.getMonth(), 0)
		return { start, end }
	},
}
